import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../kiosk';
import KioskPage from '@/features/kiosk/pages/KioskPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/',
  component: KioskPage,
});
